/*
 * @Author: your name
 * @Date: 2021-12-09 22:52:16
 * @LastEditTime: 2022-03-25 10:58:44
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /download/src/data/envs.ts
 */
import { IEnv } from '@ysfe/request'

/** 交易虎 后端接口配置 */
export const envs: Array<IEnv> = [
    {
        name: 'production',
        rule: () => true,
        baseURL: 'https://gateway.ezjld.com/iu-sdk',
        order: -1
    },
    {
        name: 'pre',
        rule: 'd-pre.ezjld.com',
        baseURL: 'https://iu-gateway-pre.ezjld.com/iu-sdk'
    },
    {
        name: 'dev',
        rule: 'd-dev.iyouhuyu.cn',
        baseURL: 'http://iu-gateway-dev.iyouhuyu.cn/iu-sdk'
    }
]
